import { render, staticRenderFns } from "./topPage.vue?vue&type=template&id=8e6ec00a&scoped=true"
import script from "./topPage.vue?vue&type=script&lang=js"
export * from "./topPage.vue?vue&type=script&lang=js"
import style0 from "./topPage.vue?vue&type=style&index=0&id=8e6ec00a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6ec00a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e6ec00a')) {
      api.createRecord('8e6ec00a', component.options)
    } else {
      api.reload('8e6ec00a', component.options)
    }
    module.hot.accept("./topPage.vue?vue&type=template&id=8e6ec00a&scoped=true", function () {
      api.rerender('8e6ec00a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/workbench/components/topPage.vue"
export default component.exports